// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__1RaYZ","icon":"Title_icon__PXQNc","saved":"Title_saved__1EMTb"};